import { Divider, Paper } from "@mui/material";
import ManualConfigurationHead from "./ManualConfigurationHead";
import AddManualConfiguration from "./AddManualConfiguration";
import ImportedObjects from "./ImportedObjects/ImportedObjects";

const ManualConfiguration = () => {
  return (
    <>
      <Paper>
        <ManualConfigurationHead />
        <Divider />
        <AddManualConfiguration />
        <ImportedObjects />
      </Paper>
    </>
  );
};

export default ManualConfiguration;
